import React from "react";
import { ButtonLink, SpanEnv } from "../../components";
import {SIGN_IN, SIGN_UP} from "../../constants/routes";

const Header = () => {
  return (
    <nav className="tenken__header-shadow">
      <div className="mx-auto xl:w-[1040px] md:w-[750px] xl:h-20 md:h-16 relative">
        <div className="float-left xl:h-20 md:h-16 flex items-center font-bold text-black xl:text-[32px] md:text-[30px]">
          点検王
        </div>
        <div className="float-right xl:h-20 md:h-16 flex items-center">
          <SpanEnv className="top-[20px]"/>
          <ButtonLink href={SIGN_IN} type="default">ログイン</ButtonLink>
          {/*<ButtonLink href={SIGN_UP} type="primary" className="ml-[12px]">新規登録</ButtonLink>*/}
        </div>
      </div>
    </nav>
  );
};

export default Header;